export class CurrencyBlockchain {
  idCurrency: number;
  idBlockchain: number;
  contract: string | null;
  main: boolean;
  locked: boolean;

  constructor(
    idCurrency: number,
    idBlockchain: number,
    contract: string | null,
    main: boolean,
    locked: boolean,
  ) {
    this.idCurrency = idCurrency;
    this.idBlockchain = idBlockchain;
    this.contract = contract;
    this.main = main;
    this.locked = locked;
  }

  static fromRaw(raw: any): CurrencyBlockchain {
    return new CurrencyBlockchain(
      raw.idCurrency,
      raw.idBlockchain,
      raw.contract === null ? null : String(raw.contract),
      Boolean(raw.main),
      Boolean(raw.locked),
    );
  }

  clone(): CurrencyBlockchain {
    return new CurrencyBlockchain(
      this.idCurrency,
      this.idBlockchain,
      this.contract,
      this.main,
      this.locked,
    );
  }

  toPayload(contractIsNull: boolean | false): any {
    return {
      idCurrency: this.idCurrency,
      idBlockchain: this.idBlockchain === 0 ? null : this.idBlockchain,
      contract: contractIsNull ? null : this.contract,
      main: this.main,
    };
  }
}
